<div [@fadeTop]="animationState" (@fadeTop.done)="onFadeFinished($event)" class="cursor-pointer w-screen max-w-xs" (click)="close()">
  <div class="px-2">
    <div [ngClass]="classList + ' rounded shadow py-2 w-full md:w-auto'">
      <p class="px-2">
        <fa-icon [icon]="data.icon" class="mr-2" [fixedWidth]="true"></fa-icon> {{ data.text }}
      </p>
    </div>
  </div>
</div>